import { type FunctionComponent } from "react";

import PageLayout from "../core/navigation-panel/PageLayout.js";
import { type IRouteNavItemProps } from "../core/navigation-panel/RouteNavItem.js";
import ParentTypesAdminPage from "./ParentTypesAdminPage.js";
import SampleAttributesAdminPage from "./SampleAttributesAdminPage.js";
import SampleTypesAdminPage from "./SampleTypesAdminPage.js";

export const SAMPLE_ADMIN_MENU_ITEMS: IRouteNavItemProps[] = [
  {
    label: "Sample Attributes",
    route: "attributes",
    pageComponent: <SampleAttributesAdminPage />,
    default: true,
  },
  {
    label: "Sample Types",
    route: "sampleTypes",
    pageComponent: <SampleTypesAdminPage />,
  },
  {
    label: "Parent Types",
    route: "parentTypes",
    pageComponent: <ParentTypesAdminPage />,
  },
];

/**
 * Samples Admin Page main component
 */
const SamplesAdminPage: FunctionComponent = () => {
  return (
    <PageLayout
      navPanelCategories={[
        {
          label: "Sample Administration",
          navItems: SAMPLE_ADMIN_MENU_ITEMS,
        },
      ]}
    />
  );
};

export default SamplesAdminPage;
